import toast from "react-hot-toast";
import { useApiMutation } from "../../hooks/use-api-mutation.hook";
import { useApiQuery } from "../../hooks/use-api-query.hook";
import { ApiMethods, CacheKeys } from "../../utils/constants";
import {
  ApiResponseType,
  PaginatedApiResponseType,
} from "../api-response.type";
import { MyProfileType } from "../common/types/my-profile.type";
import { InviteAdminType } from "./schemas/invite-admin.schema";

export function useGetProfile() {
  return useApiQuery<ApiResponseType<MyProfileType>>(
    [CacheKeys.PROFILE],
    "/user/profile",
    {},
  );
}

export function useGetUsersPaginated(data: {
  page: number;
  limit: number;
  search?: string;
  emailVerified?: string;
  status?: string;
  hasActiveSubscription?: string;
  gender?: string;
  isExpressRegistration?: string;
  userType?: string;
}) {
  const searchQuery = data.search ? `&search=${data.search}` : "";
  const emailVerifiedQuery = data.emailVerified
    ? `&emailVerified=${data.emailVerified}`
    : "";
  const statusQuery = data.status ? `&status=${data.status}` : "";
  const hasActiveSubscriptionQuery = data.hasActiveSubscription
    ? `&hasActiveSubscription=${data.hasActiveSubscription}`
    : "";
  const genderQuery = data.gender ? `&gender=${data.gender}` : "";
  const isExpressRegistrationQuery = data.isExpressRegistration
    ? `&isExpressRegistration=${data.isExpressRegistration}`
    : "";
  const userTypeQuery = data.userType ? `&userType=${data.userType}` : "";

  return useApiQuery<PaginatedApiResponseType<MyProfileType[]>>(
    [
      CacheKeys.USERS,
      `${CacheKeys.USERS}:${
        data.page
      }-${data.limit}-${data.search}-${data.emailVerified}-${data.status}-${data.hasActiveSubscription}-${data.gender}-${
        data.isExpressRegistration
      }-${data.userType}`,
    ],
    `/user_admin?page=${data.page}&limit=${data.limit}${searchQuery}${emailVerifiedQuery}${statusQuery}${hasActiveSubscriptionQuery}${genderQuery}${isExpressRegistrationQuery}${userTypeQuery}`,
    {},
  );
}

export function useUpdateUser(modal: { onClose: () => void }) {
  return useApiMutation<Partial<MyProfileType>, ApiResponseType<undefined>>(
    "/user_admin/profile/:id",
    ApiMethods.PATCH,
    [CacheKeys.USERS],
    {
      onSuccess: () => {
        toast.success("User updated successfully");
        modal.onClose();
      },
    },
  );
}

export function useInviteAdmin(modal: { onClose: () => void }) {
  return useApiMutation<InviteAdminType, ApiResponseType<undefined>>(
    "/user_admin/invite",
    ApiMethods.POST,
    [CacheKeys.USERS],
    {
      onSuccess: () => {
        toast.success("Admin invited successfully");
        modal.onClose();
      },
    },
  );
}
